<template>
  <div style="height: 100vh; background-color: #ffffff">
    <vue-element-loading
      style="z-index: 99999;"
      is-full-screen
      :active="fullLoading"
      spinner="bar-fade-scale"
      color="#152d51"
    />
    <div class="navbar nav-main w-100" style="background-color: #23409a; color: white">
      <h3 class="w-100 text-center my-3">ลงทะเบียนสำเร็จ</h3>
    </div>
    <div class="w-100 pt-5 px-5 session-with-nav">
      <h6 class="text-gray">
        <template v-if="hasEtaxBill">
          รายการสัญญาของคุณ
          สามารถรับบริการทั่วไปและบริการจัดส่งใบแจ้งหนี้/ใบเสร็จ/ใบกำกับภาษีอิเล็กทรอนิคส์ผ่าน Next
          Connect ได้
        </template>
        <template v-else> รายการสัญญาของคุณ สามารถรับบริการทั่วไปผ่าน Next Connect ได้ </template>
      </h6>
    </div>

    <template v-if="ncapContract && ncapContract.length">
      <div class="mb-2  flex-all-center">
        <div>
          <v-img
            class="my-0 radius-circle"
            style="width: 170px; height: auto"
            src="@/assets/logo_long.png"
          ></v-img>
        </div>
      </div>
      <v-layout row justify-space-between class="row-menu m-0">
        <div class="pl-0 text-primary-2" style="width: max-content; color: black">
          <img
            style="height: 24px;"
            class="pr-2"
            src="@/assets/icon/Motorcycle.svg"
            alt="title-lone"
          />บัญชีสินเชื่อเช่าซื้อ
        </div>
        <div
          @click="showContactNCap = !showContactNCap"
          class="text-primary-2 p-0"
          :style="
            `width: max-content; cursor:pointer;${
              showContactNCap ? 'transform: rotate(-90deg)' : ''
            }`
          "
        >
          <img style="height:24px" src="@/assets/profile-new/side.png" alt="side" />
        </div>
      </v-layout>

      <div class="w-100 px-5" v-if="showContactNCap">
        <div
          class="item-contact text-blue mb-4 d-flex justify-content-between"
          v-for="(item, index) in ncapContract"
          :key="`contact-list-${index}`"
          @click="selectContract(item, 'ncap')"
        >
          <span>
            <v-icon class="text-blue">mdi-file-document-edit-outline</v-icon> เลขที่สัญญา
            {{ item.agreementNo ? item.agreementNo : '-' }}
          </span>
          <span
            ><v-btn outlined icon color="#23409a" x-small
              ><span class="fs-17" style="margin-left: 3px"
                ><v-img
                  style="width: 9px; height: auto"
                  src="@/assets/vector.svg"
                ></v-img></span></v-btn
          ></span>
        </div>
      </div>
      <div class="text-center mt-8 pb-5 w-100 px-5">
        <template v-if="!hasEtaxBill">
          <div class="text-center">
            กดถัดไปเพื่อลงทะเบียนรับใบแจ้งหนี้/ใบเสร็จ/ใบกำกับภาษีอิเล็กทรอนิคส์/หนังสือแจ้งข้อมูลประวัติการชำระสินเชื่อ
          </div>

          <v-btn
            :loading="loading"
            class="col-8 main-btn mt-2"
            style="color: white"
            color="#23409a"
            :href="linkToEtaxBill"
          >
            ถัดไป
          </v-btn>

          <v-btn :loading="loading" @click="backtoChat" class="col-12" text color="#23409a">
            ข้าม
          </v-btn>
        </template>
        <template v-else>
          <v-btn
            :loading="loading"
            @click="backtoChat"
            class="col-8 main-btn"
            style="color: white"
            color="#23409a"
          >
            กลับสู่แชท
          </v-btn>
        </template>
      </div>
    </template>

    <div v-else-if="!ncapContract && !nmnyContract" class="w-100 px-5">
      <div class="mb-2  flex-all-center">
        <div>
          <v-img
            class="my-0 radius-circle"
            style="width: 170px; height: auto"
            src="@/assets/logo_long.png"
          ></v-img>
        </div>
      </div>
      <div class="text-center mt-7">สัญญาอยู่ระหว่างดำเนินการ</div>
    </div>
    <div v-if="nmnyContract && nmnyContract.length">
      <div class="mb-2 session-with-nav flex-all-center">
        <div>
          <v-img
            class="my-0 radius-circle"
            style="width: 170px; height: auto"
            src="@/assets/logo_long_nm.png"
          ></v-img>
        </div>
      </div>
      <v-layout row justify-space-between class="row-menu m-0">
        <div class="pl-0 text-primary-2" style="width: max-content; color: black">
          <img
            style="height: 24px;"
            class="pr-2"
            src="@/assets/icon/titleloan.svg"
            alt="title-lone"
          />บัญชีสินเชื่อจำนำเล่มทะเบียน
        </div>
        <div
          @click="showContactNMny = !showContactNMny"
          class="text-primary-2 p-0"
          :style="
            `width: max-content; cursor:pointer;${
              showContactNMny ? 'transform: rotate(-90deg)' : ''
            }`
          "
        >
          <img style="height:24px" src="@/assets/profile-new/side.png" alt="side" />
        </div>
      </v-layout>
      <div v-if="showContactNMny" class="w-100 px-5">
        <div
          class="item-contact text-green mb-4 d-flex justify-content-between"
          v-for="(item, index) in nmnyContract"
          :key="`contact-list-${index}`"
          @click="selectContract(item, 'nmny')"
        >
          <span>
            <v-icon class="text-green">mdi-file-document-edit-outline</v-icon> เลขที่สัญญา
            {{ item.agreementNo ? item.agreementNo : '-' }}
          </span>
          <span
            ><v-btn outlined icon color="#007a47" x-small
              ><span class="fs-17" style="margin-left: 3px"
                ><v-img
                  style="width: 9px; height: auto"
                  src="@/assets/vector-nmny.svg"
                ></v-img></span></v-btn
          ></span>
        </div>
      </div>
      <div class="text-center mt-8 pb-5 w-100 px-5">
        <template v-if="!hasNmEtaxBill">
          <div class="text-center">
            กดถัดไปเพื่อลงทะเบียนรับใบแจ้งหนี้/ใบเสร็จ/หนังสือแจ้งข้อมูลประวัติการชำระสินเชื่อ
          </div>

          <v-btn
            :loading="loading"
            class="col-8 main-btn mt-2"
            style="color: white"
            color="#007a47"
            :href="linkToNMEtaxBill"
          >
            ถัดไป
          </v-btn>

          <v-btn :loading="loading" @click="backtoChat" class="col-12" text color="#007a47">
            ข้าม
          </v-btn>
        </template>
        <template v-else>
          <v-btn
            :loading="loading"
            @click="backtoChat"
            class="col-8 main-btn"
            style="color: white"
            color="#007a47"
          >
            กลับสู่แชท
          </v-btn>
        </template>
      </div>
    </div>
    <v-dialog
      v-model="show"
      scrollable
      fullscreen
      persistent
      max-width="500px"
      transition="dialog-bottom-transition"
    >
      <v-card v-if="selectContractData && selectSource" class="py-2 px-5">
        <v-toolbar
          dark
          class="position-fixed col-12"
          style="height: 56px; top: 0; z-index: 2"
          :color="color"
        >
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>รายละเอียดยอด</v-toolbar-title>
        </v-toolbar>
        <div style="margin-top: 80px; background-color: white">
          <h6 class="pl-5 text-blue mb-8" :style="`color: ${color} !important`">
            รายละเอียดสัญญาเลขที่ {{ selectContractData.agreementNo }}
          </h6>
          <contractTable :showData="selectContractData" :color="color" />
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import contractTable from '../contractTable.vue'
import moment from 'moment'
import config from '@/config'
import contractApi from '@/api/contract.js'
import VueElementLoading from 'vue-element-loading'
import { formatThaiDate } from '@/utils/dateFormat'
export default {
  components: { contractTable, VueElementLoading },
  data() {
    return {
      loading: false,
      show: false,
      selectContractData: null,
      selectSource: null,
      fullLoading: false,
      ncapContract: null,
      nmnyContract: null,
      showContactNCap: true,
      showContactNMny: true
    }
  },
  mounted() {
    this.fetchContractDetail()
  },
  computed: {
    linkToEtaxBill() {
      return this.$store.getters.getLinkEtax
    },
    idcard() {
      return this.$store.state.regisData.idcard
    },
    query() {
      return this.$store.state.query
    },
    view() {
      return this.$store.state.query.view
    },
    input() {
      return this.$store.state.regisData ? this.$store.state.regisData : null
    },
    regisData() {
      return this.$store.state.regisData ? this.$store.state.regisData : null
    },
    hasRegisteredAccount() {
      return this.$store.state.hasRegisteredAccount
    },
    hasEtaxBill() {
      return this.$store.state.hasEtaxBill
    },
    showData() {
      return this.$store.state.showData ? this.$store.state.showData : null
    },
    nmShowData() {
      return this.$store.state.nmShowData ? this.$store.state.nmShowData : null
    },
    color() {
      if (this.selectSource == 'nmny') {
        return '#007a47'
      }
      return '#23409a'
    },
    hasNmEtaxBill() {
      return this.$store.state.hasNmEtaxBill
    },
    linkToNMEtaxBill() {
      return this.$store.getters.getNMLinkEtax
    }
  },
  methods: {
    backtoChat() {
      this.$liff.closeWindow()
    },
    selectContract(item, source) {
      this.selectContractData = item
      this.show = true
      this.selectSource = source
    },
    async fetchContractDetail() {
      this.fullLoading = true
      try {
        const configApi = {
          body: {
            page_id: config.pageid,
            id_card: this.input.idcard,
            birth_day: formatThaiDate(this.input.date)
          },
          config: {}
        }
        const response = await contractApi.getLoanInfo(configApi)
        this.ncapContract = response?.data?.data?.ncapLoanInfoList
        this.nmnyContract = response?.data?.data?.nmnyLoanInfoList
      } catch (error) {
        console.error(error)
        this.$swal.fire({
          type: 'error',
          text: 'เรียกข้อมูลไม่สำเร็จ'
        })
      } finally {
        this.fullLoading = false
      }
    }
  }
}
</script>

<style>
.v-tooltip__content {
  background-color: #fafafa !important;
  color: black !important;
  max-width: 80%;
  border: 1px solid #ebebeb !important;
  box-sizing: border-box !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
  border-radius: 10px !important;
}
.v-application .primary--text {
  color: #23409a !important;
  caret-color: #23409a !important;
}
.slidedealer,
.slidedealer-back {
  &-enter-active,
  &-leave-active {
    position: absolute;
    width: 100%;
    background: white;
    min-height: 100vh;
    top: 12px;
  }
}
// router view
.slidedealer-enter-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(100%);
}
.slidedealer-enter-to {
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-leave-active {
  z-index: -1;
}
.slidedealer-leave-to {
  z-index: -1;
}
// router view back

.slidedealer-back-enter-active {
  z-index: -1;
}
.slidedealer-back-enter-to {
  z-index: -1;
}

.slidedealer-back-leave-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-back-leave-to {
  transform: translateX(100%);
  z-index: 2;
}
.addcartbtn {
  position: fixed;
  text-align: center;
  padding-top: 15px;
  z-index: 1;
  font-size: 23px;
  bottom: 0px;
  background-color: rgb(12, 77, 157);
  width: 90vw;
  height: 60px;
  color: white;
  border-radius: 13px 13px 0px 0px;
  left: 50%;
  transform: translate(-50%, 0);
}
.myshadow {
  -webkit-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
  box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.95);
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
